import React from "react";
import Skeleton from "react-loading-skeleton"; // Import Skeleton
import "react-loading-skeleton/dist/skeleton.css"; // Import Skeleton styles

const Equipe = (props) => {
  // Show skeleton if members are not loaded
  if (!props?.members) {
    return (
      <div className="">
        <h3 className="grey500">
          <Skeleton width={100} />
        </h3>
        <div className="row">
          {[...Array(4)].map((_, index) => (
            <div key={index} className="col-md-3 col-xs-6 px-0">
              <div className="card-twyny">
                <Skeleton width={120} height={40} />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // When members data is loaded, render the actual content
  return (
    <div className="twyny-border-bottom">
         <div className="container">
      <h3 className="grey500 mb-0">L’équipe</h3>
      <div className="row mt-16 ">
        {props?.members?.map((member, index) => (
          <div key={index} className=" col-xs-3 col-md-3 mx-0 px-0 ">
            <div className="card-twyny mr-8 body bold500 grey500 text-center">
              {member?.name}
            </div>
          </div>
        ))}
      </div></div>
    </div>
  );
};

export default Equipe;
